<modal-panel class="modal-panel filter-panel" title="Filter" (close)="close()">
  <div class="filter" [formGroup]="form">
    <div class="filter__fields">
      <mat-grid-list [cols]="isSmall ? 1 : 2" gutterSize="20px" rowHeight="85">
        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Date From</mat-label>
            <input
              matInput
              readonly
              [min]="dateRange.fromMin()"
              [max]="dateRange.fromMax()"
              [matDatepicker]="picker"
              formControlName="DateFrom"
            />
            <mat-hint>MM/DD/YYYY</mat-hint>
            @if (dateFromError) {
              <mat-error>{{ dateFromError }}</mat-error>
            }
            <mat-datepicker #picker/>
            @if (showDateFromClearIcon) {
              <button
                matSuffix
                mat-icon-button
                (click)="resetFilter('DateFrom')"
              >
                <mat-icon fontIcon="close"></mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="picker"/>
            }
          </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile>
          <mat-form-field>
            <mat-label>Date To</mat-label>
            <input
              matInput
              readonly
              [min]="dateRange.toMin()"
              [max]="dateRange.toMax()"
              [matDatepicker]="picker2"
              formControlName="DateTo"
            />
            <mat-hint>MM/DD/YYYY</mat-hint>
            @if (dateToError) {
              <mat-error>{{ dateToError }}</mat-error>
            }
            <mat-datepicker #picker2/>
            @if (showDateToClearIcon) {
              <button
                matSuffix
                mat-icon-button
                (click)="resetFilter('DateTo')"
              >
                <mat-icon fontIcon="close"></mat-icon>
              </button>
            } @else {
              <mat-datepicker-toggle matIconSuffix [for]="picker2"/>
            }
          </mat-form-field>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
    @if (!isFormValid) {
      <div class="filter__validation-message">
        <mat-icon color="warn">error_outline</mat-icon>
        <span>Please make sure "Date To" is greater than or equal to "Date From".</span>
      </div>
    }
  </div>
  <ng-container modalPanelFooter>
    <button mat-raised-button color="primary" (click)="apply()" [disabled]="!isFormValid">Apply</button>
  </ng-container>
</modal-panel>
